import type { IllustrationProps } from './types';
import {
  ILLUSTRATION_PALETTE,
  CarFigure,
  IllustrationSvg,
  SkyBackdrop,
  SlopeSurface,
  StruggleMark,
} from './shared';

export default function CarStruggleIllustration({
  className,
  width,
  height,
  primaryColor,
  accentColor,
}: IllustrationProps) {
  const accent = accentColor ?? ILLUSTRATION_PALETTE.struggle;

  return (
    <IllustrationSvg className={className} width={width} height={height} title="Araç zorlanıyor">
      <SkyBackdrop accent={accent} />
      <SlopeSurface startY={48} endY={24} accent={accent} />
      <CarFigure cx={44} cy={18} tilt={-16} primary={primaryColor} />
      <StruggleMark x={58} y={10} />
    </IllustrationSvg>
  );
}
